<div class="documentBox documents">
 


<mat-accordion>

  <mat-expansion-panel [expanded]="true" >

    <mat-expansion-panel-header>
      <mat-panel-title class="header" >
        <div class="titleCount">
              <div class="folderName">Photos<span class="count">2</span></div>
        </div>
       
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="documentcontainer">
      <ul>
        <li>
          <div class="documentList file">
              <div class="uploadholder ">
                <mat-icon>backup</mat-icon>
                <p>Upload Photos</p>
                <input type="file">
              </div>
              <div class="uplsub">
              <button class="upload" mat-stroked-button color="primary">Upload</button>
            </div>
          </div>
        </li> 
        <li >
          <div class="documentList">
            <img class="photo" src="../../../../../assets/images/avatars/danielle.jpg" alt="Word File">
            <div class="opt_holder">
                <!-- <div class="checkmenu">
                    <button mat-icon-button><mat-icon>more_vert</mat-icon></button>
                </div> -->
                <div class="nameact">
                      <div class="typename" >
                          <span class="name">DreamHome2015</span>
                      </div>
                      <div class="docactions" >
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Download" >
                          <img src="../../../../../assets/images/icons/download.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as default" >
                          <img src="../../../../../assets/images/icons/set_default.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as QR code" >
                          <img src="../../../../../assets/images/icons/qr_code.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Delete" >
                          <img src="../../../../../assets/images/icons/trash.svg">
                        </button>
                      </div>
                </div>
            </div>            
            </div>
        </li>
        <li >
            <div class="documentList">
              <img class="photo" src="../../../../../assets/images/avatars/Henderson.jpg" alt="Word File">
              <div class="opt_holder">
                <!-- <div class="checkmenu">
                    <button mat-icon-button><mat-icon>more_vert</mat-icon></button>
                </div> -->
                <div class="nameact">
                      <div class="typename" >
                          <span class="name">DreamHome2015</span>
                      </div>
                      <div class="docactions" >
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Download" >
                          <img src="../../../../../assets/images/icons/download.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as default" >
                          <img src="../../../../../assets/images/icons/set_default.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as QR code" >
                          <img src="../../../../../assets/images/icons/qr_code.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Delete" >
                          <img src="../../../../../assets/images/icons/trash.svg">
                        </button>
                      </div>
                </div>
            </div>              
              </div>
          </li>
          <li >
            <div class="documentList">
              <img class="photo" src="../../../../../assets/images/avatars/Shepard.jpg" alt="Word File">
              <div class="opt_holder">
                <!-- <div class="checkmenu">
                    <button mat-icon-button><mat-icon>more_vert</mat-icon></button>
                </div> -->
                <div class="nameact">
                      <div class="typename" >
                          <span class="name">DreamHome2015</span>
                      </div>
                      <div class="docactions" >
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Download" >
                          <img src="../../../../../assets/images/icons/download.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as default" >
                          <img src="../../../../../assets/images/icons/set_default.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as QR code" >
                          <img src="../../../../../assets/images/icons/qr_code.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Delete" >
                          <img src="../../../../../assets/images/icons/trash.svg">
                        </button>
                      </div>
                </div>
            </div>            
              </div>
          </li>
          <li >
            <div class="documentList">
              <img class="photo" src="../../../../../assets/images/avatars/katherine.jpg" alt="Word File">
              <div class="opt_holder">
                <!-- <div class="checkmenu">
                    <button mat-icon-button><mat-icon>more_vert</mat-icon></button>
                </div> -->
                <div class="nameact">
                      <div class="typename" >
                          <span class="name">DreamHome2015</span>
                      </div>
                      <div class="docactions" >
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Download" >
                          <img src="../../../../../assets/images/icons/download.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as default" >
                          <img src="../../../../../assets/images/icons/set_default.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Set as QR code" >
                          <img src="../../../../../assets/images/icons/qr_code.svg">
                        </button>
                        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Delete" >
                          <img src="../../../../../assets/images/icons/trash.svg">
                        </button>
                      </div>
                </div>
            </div>            
              </div>
          </li>
      </ul>
  </div>
  

  </mat-expansion-panel>

</mat-accordion>



</div>



